/*
document.addEventListener('DOMContentLoaded', function() {
	function getIndex(element) {
		let i = 0;
		while ((element = element.previousSibling) != null) ++i;
		return i;
	}

	let
	selects1 = document.querySelectorAll('.form-select-1'),
	options1 = document.querySelectorAll('.form-select-1--button'),
	selectOverlay = document.querySelectorAll('.form-select-1--ul-wrapper');

	if (selects1 != undefined) {
		selects1.forEach(el => {
			el.querySelector('.form-select-1--selected').addEventListener('click', _selected => {
				let
				selected = _selected.target,
				selectedCSS = selected.classList,
				select = selected.parentNode,
				selectCSS = select.classList,
				toggle = selected.nextElementSibling,
				_css = 'active',
				bodyCSS = document.body.classList,
				_bodyCSS = 'modal-open';
			
				if (selectCSS.contains(_css)) {
					selectCSS.remove(_css);
					bodyCSS.remove(_bodyCSS);
				} else {
					selectCSS.add(_css);
					bodyCSS.add(_bodyCSS);
				}
			});
		});
	}

	if (options1 != undefined) {
		options1.forEach(el => {
			el.addEventListener('click', (_option, i) => {
				let
				option = _option.target,
				optionCSS = option.classList,
				select = option.parentNode.parentNode.parentNode,
				selectedOption = option.parentNode.parentNode.previousElementSibling,
				index = getIndex(option),
				hiddenSelect = select.nextElementSibling.children[0];
				
				// Hide modal
				select.classList.remove('active');
				document.body.classList.remove('modal-open');

				// Trigger click on real select
				if (hiddenSelect != undefined) {
					hiddenSelect.value = index + 1;
				}
				
				// Sets selected text
				selectedOption.innerText = option.innerText;
			})
		});
	}

	if (selectOverlay != undefined) {
		selectOverlay.forEach(el => {
			el.addEventListener('click', _overlay => {
				let
				overlay = _overlay.target;
				overlay.parentNode.classList.remove('active');
				document.body.classList.remove('modal-open');
			});
		});
	}

});

*/